export default __webpack_public_path__ + "static/media/AtomsAndCompounds _21.50fafc4a.png";